// extracted by mini-css-extract-plugin
module.exports = {"CountdownContainer":"Loader_CountdownContainer__1Uq2I","value":"Loader_value__1rJlQ","LoadingText":"Loader_LoadingText__1jcpj","LoadingSubText":"Loader_LoadingSubText__1v1Er"};